import { getImageUrl } from '../../client/utils/helpers';

export function removeQuotes(text) {
  if (!text) {
    return null;
  }
  const t = text.length;
  let editedString = text;
  if (editedString.charAt(0) === '"') {
    editedString = editedString.substring(1, t - 1);
  }
  if (editedString.charAt(t - 1) === '"') {
    editedString = editedString.substring(0, t);
  }
  return editedString;
}

export function convertToSlug(text) {
  let slug = text;
  if (text === 'Lodi Rosé') slug = 'Lodi Rose';
  else if (text === 'Sonoma Reserve Rosé') slug = 'Sonoma Reserve Rose';
  else if (text === 'North Coast Reserve Sparkling Rosé') {
    slug = 'North Coast Reserve Sparkling Rose';
  } else if (text === 'Rutherford Estate Fumé Blanc') {
    slug = 'Rutherford Estate Fume Blanc';
  }
  return slug
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/[^\w-]+/g, '');
}

// Temporary
export const ceEnrollmentLaunchDate = '2019-07-01T05:00:00.000Z';

export const getProfileImage = (user: any) => {
  const { profile } = user;
  return profile && profile.image
    ? getImageUrl(profile.image, 'thumb')
    : `/profile/default_profile.svg`;
};

